import { CancelToken } from 'axios';

import { CANCEL_FETCH_MESSAGE } from 'hb-react/shared/constants/cancelFetch';

import { HTTP_STATUS_CODE_403 } from '../constants/httpStatusCode';
import { CATEGORY } from '../constants/types';
import fetchCategory from '../requests/fetchCategory';

const handleFetchCategory = async ({
  cancelTokenRef,
  id,
  isFetching,
  setCurrentView,
  setIsFetching,
  setSelectedCategory,
  setSelectedSuperCategory,
  setUserAuthorizationInfo,
  withCategorySet,
}) => {
  if (isFetching && cancelTokenRef.current) {
    cancelTokenRef.current.cancel(CANCEL_FETCH_MESSAGE);
  }
  cancelTokenRef.current = CancelToken.source();

  setIsFetching(true);

  const response = await fetchCategory({
    cancelToken: cancelTokenRef?.current,
    id,
    withCategorySet,
  });

  if (response?.response?.status === HTTP_STATUS_CODE_403) {
    setUserAuthorizationInfo({ isAuthorized: false, error: response });
  } else {
    setUserAuthorizationInfo({ isAuthorized: true });

    if (response?.category) {
      if (withCategorySet) {
        setSelectedSuperCategory(response.superCategory);
      }

      setSelectedCategory(response.category);
      setIsFetching(false);
      setCurrentView(CATEGORY);
    }
  }
};

export default handleFetchCategory;
